import { render } from "./ChartTabs.vue?vue&type=template&id=0b01483a&scoped=true"
import script from "./ChartTabs.vue?vue&type=script&lang=js"
export * from "./ChartTabs.vue?vue&type=script&lang=js"

import "./ChartTabs.vue?vue&type=style&index=0&id=0b01483a&lang=scss&scoped=true"

import exportComponent from "C:\\laragon\\www\\runpixie_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b01483a"]])

export default __exports__
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QTabPanels from 'quasar/src/components/tab-panels/QTabPanels.js';
import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import qInstall from "../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSkeleton,QTabs,QTab,QSelect,QTabPanels,QTabPanel,QSpinner});
